<template>
    <footer class="text-center">
        <img src="../media/logo_untrr.png" alt="UNTRR" class="logo"><br/>
        <div class="row">
            <div class="col-sm-3">
                <router-link :to="{name: 'terms'}">{{ $t('terms') }}</router-link><br/>
                <router-link :to="{name: 'confidentiality'}">{{ $t('new_account_pc') }}</router-link><br/>
                <router-link :to="{name: 'cookies'}">{{ $t('cookies') }}</router-link><br/>
                <router-link :to="{name: 'partners'}">{{ $t('partners') }}</router-link>
                <router-link :to="{name: 'vignette'}">ANPC</router-link><br/>
                <router-link :to="{name: 'info'}">{{ $t('info') }}</router-link><br/>
            </div>
        </div>
        <br/>
        <p class="">{{ $t('footer_copyright') }}</p>
        <p>Developed by <a href="https://controlf5.ro" target="_blank"><img src="../media/logo-controlf5.png" class="ctrlf5" alt="Control F5"></a></p>
    </footer>
</template>

<script>

export default {
    name: 'FooterMobile',
    data: function() {
        return {
        };
    },
    components: {
    },
    props: {
    },
    computed: {
    },
    mounted: function() {
    },
    methods: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

img {
    max-width: 100%;
}

a {
    color: #666;
    display: inline-block;
    margin-bottom: 5px;
}

p {
    color: #666;
}

footer {
    padding: 0 15px;
}

.logo {
    max-width: 150px;
}

.ctrlf5 {
    max-height: 35px;
    vertical-align: middle;
    margin-left: 5px;
    margin-top: 5px;
}

.payu {
    max-height: 35px;
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
}

.partners {
    a {
        display: inline-block;
        margin-right: 10px;
    }
}

</style>
